import React from 'react';
import { BrowserRouter } from 'react-router-dom/cjs/react-router-dom.min';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRouter from './AppRouter.jsx';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <Provider store={ store } >
   
    <AppRouter />
   
  </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
